import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, Transition as _Transition, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-primary-700 font-bold whitespace-nowrap" }
const _hoisted_2 = { class: "px-4" }
const _hoisted_3 = { class: "px-4" }
const _hoisted_4 = { class: "px-4 mt-5" }

import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue'
import { UserCircleIcon, ChevronDownIcon } from '@heroicons/vue/24/outline'
import AuthService from "@/classes/AuthService";
import patient from "@/classes/UserData";
import { useRouter } from 'vue-router';

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuButton',
  setup(__props) {

const router = useRouter();

const patientData = computed(() => patient.getCurrentUser())

const logout = () => {
    AuthService.logout()
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Menu), {
    as: "div",
    class: "relative inline-block text-left"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_unref(MenuButton), { class: "w-full flex items-center px-4 py-2 outline-none ring-0 space-x-3" }, {
          default: _withCtx(() => [
            _createVNode(_unref(UserCircleIcon), {
              class: "h-6 w-6 text-primary-500",
              "aria-hidden": "true"
            }),
            _createElementVNode("span", _hoisted_1, _toDisplayString(`${patientData.value.first_name} ${patientData.value.last_name}`), 1),
            _createVNode(_unref(ChevronDownIcon), {
              class: "h-5 w-5 text-gray-10/30",
              "aria-hidden": "true"
            })
          ]),
          _: 1
        })
      ]),
      _createVNode(_Transition, {
        "enter-active-class": "transition duration-100 ease-out",
        "enter-from-class": "transform scale-95 opacity-0",
        "enter-to-class": "transform scale-100 opacity-100",
        "leave-active-class": "transition duration-75 ease-in",
        "leave-from-class": "transform scale-100 opacity-100",
        "leave-to-class": "transform scale-95 opacity-0"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(MenuItems), { class: "absolute left-0 bottom-10 mt-2 w-full origin-top-right rounded-[5px] bg-white border border-gray-30" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_unref(MenuItem), null, {
                  default: _withCtx(({ active }) => [
                    _createElementVNode("button", {
                      class: _normalizeClass([
                            active ? 'text-black' : 'text-darkgray-400',
                            'pt-2',
                            ]),
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/account-details')))
                    }, " Account Details ", 2)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_unref(MenuItem), null, {
                  default: _withCtx(({ active }) => [
                    _createElementVNode("button", {
                      class: _normalizeClass([
                            active ? 'text-black' : 'text-darkgray-400',
                            'pt-2',
                            ]),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push('/change-password')))
                    }, " Change Password ", 2)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_unref(MenuItem), null, {
                  default: _withCtx(({ active }) => [
                    _createElementVNode("button", {
                      onClick: logout,
                      class: _normalizeClass([
                                active ? 'text-black' : 'text-darkgray-400','py-2',
                            ])
                    }, " Logout ", 2)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})